import { NavLink } from "react-router-dom";
import BackgroundHome from "../assets/home.jpg";
import BackgroundSkills from "../assets/image4.jpg";
import BackgroundContact from "../assets/image2.jpg";

import "../Css/NavBar.css";
import { useEffect, useState } from "react";
export default function NavBar({ setBackimg }) {
  let [url, setUrl] = useState("");
  useEffect(() => {
    async function getResumeUrl() {
      let response = await fetch(
        "https://raw.githubusercontent.com/GitUserVivek/JsonServer/main/db.json"
      );

      let data = await response.json();
      let link = data?.resume?.link;
      setUrl(link);
    }

    getResumeUrl();
  }, []);

  return (
    <div className="NavBarPage">
      <NavLink
        onClick={() => {
          setBackimg(BackgroundHome);
        }}
        to="/Home"
      >
        Home
      </NavLink>
      <NavLink
        activeClassName="active"
        onClick={() => {
          setBackimg(BackgroundSkills);
        }}
        to="/About"
      >
        About
      </NavLink>
      <a target="_blank" rel="noreferrer" href={url} download>
        Résumé
      </a>
      <NavLink
        activeClassName="active"
        onClick={() => {
          setBackimg(BackgroundContact);
        }}
        to="/Contact"
      >
        Contact
      </NavLink>
    </div>
  );
}
